import { useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";

const ScrollToTop = () => {
  const loc = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    const scrollableContainers = document.querySelectorAll(
      ".overflow-y-auto, .overflow-auto"
    );
    scrollableContainers.forEach((container) => {
      container.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    });
  }, [loc.pathname]);

  return null;
};

export { ScrollToTop };
